import { useEffect } from 'react'
import { Icon, Button } from '@/components/atoms'
import './notificationalert.scss';

const NotificationAlert = ({ type, message, show = false, onCloseClick, handleClick, iconType, arrowButton, buttonShow = false, handleArrow }) => {

  useEffect(() => {
    if (!show) return
  }, [message, onCloseClick, show, type])

  if (!show) return null

  return (
    <div
      data-testid={`alert-${type}`}
      className={`alert-toast-notification alert-${type} my-4 gap-4`}
      role="alert"
    >
      <div className="inline-flex h-6 w-6 items-center justify-center rounded-lg -mr-6 mt-1.5">
          <Icon icon={iconType} size="large" isDark={false} />
      </div>
      <div className="text-md ml-3 flex-1 py-0 pl-1 items-start">
        {message && (
          <div className={`text-sm text-white flex items-center justify-between`}> {/* Added justify-between to align button to the right */}
            <div>
              <div className="title font-bold">{message.title}</div> {/* First line in bold */}
              <div className="sub-title">{message.subTitle}</div> {/* Second line in normal text */}
            </div>
            {!buttonShow && (
              arrowButton ? (
                <Button
                  handleButton={handleArrow}
                  uiSchema={{
                    className: "button-arrow ml-4 mt-1 inline-flex items-center justify-center text-icon",
                    title: <Icon icon="arrow_forward" size="large"/>,
                    size: "medium",
                    variant: "primary",
                  }}
                />
              ) : (
                <Button
                  handleButton={handleClick}
                  uiSchema={{
                    className: "button-close ml-4 mt-1 inline-flex items-center justify-center text-icon",
                    title: "Close",
                    size: "medium",
                    variant: "primary",
                  }}
                />
              )
            )}
          </div>
        )}
      </div>
    </div>
  )
}


export default NotificationAlert
